import React, { useState, useEffect, useCallback } from 'react';
import { ReloadOutlined } from '@ant-design/icons';

const Captcha = ({ value, onChange }) => {
  const [captchaText, setCaptchaText] = useState('');

  // 生成随机验证码
  const generateCaptcha = useCallback(() => {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = 0; i < 4; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptchaText(result);
    if (onChange) {
      onChange(result); // 通知父组件验证码值
    }
  }, [onChange]);

  // 组件挂载时生成验证码
  useEffect(() => {
    generateCaptcha();
  }, [generateCaptcha]); // 添加generateCaptcha依赖

  // 当value为空时重新生成验证码
  useEffect(() => {
    if (!value) {
      generateCaptcha();
    }
  }, [value, generateCaptcha]); // 添加generateCaptcha依赖

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      height: '48px',
      borderRadius: '8px',
      border: '1px solid #d9d9d9',
      background: '#f5f5f5',
      padding: '0 12px',
      cursor: 'pointer',
      userSelect: 'none',
      transition: 'all 0.3s ease'
    }}
    onClick={generateCaptcha}
    onMouseEnter={(e) => {
      e.target.style.borderColor = '#1890ff';
      e.target.style.boxShadow = '0 0 0 2px rgba(24, 144, 255, 0.2)';
    }}
    onMouseLeave={(e) => {
      e.target.style.borderColor = '#d9d9d9';
      e.target.style.boxShadow = 'none';
    }}
    >
      <div style={{
        flex: 1,
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#1890ff',
        textAlign: 'center',
        letterSpacing: '2px',
        fontFamily: 'monospace',
        background: 'linear-gradient(45deg, #1890ff, #722ed1)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }}>
        {captchaText}
      </div>
      <ReloadOutlined 
        style={{ 
          color: '#666', 
          fontSize: '16px',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.color = '#1890ff';
          e.target.style.transform = 'rotate(180deg)';
        }}
        onMouseLeave={(e) => {
          e.target.style.color = '#666';
          e.target.style.transform = 'rotate(0deg)';
        }}
      />
    </div>
  );
};

export default Captcha; 